import { render, staticRenderFns } from "./LatestReferrals.vue?vue&type=template&id=56d84c14&scoped=true&"
import script from "./LatestReferrals.vue?vue&type=script&lang=js&"
export * from "./LatestReferrals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d84c14",
  null
  
)

export default component.exports